import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CiComplaintsComponent } from 'app/ci-repack/ci-complaints/ci-complaints.component';
import { InvWorkstationComponent } from 'app/formulary-inventory/inv-workstation/inv-workstation.component';
import { QuickUserInfoComponent } from 'app/shared/quick-user-info/quick-user-info.component';
import { PrimeNgModule } from '../../shared/primeNg.module';
import { SharedModule } from '../../shared/shared.module';
import { PushNotificationModule } from '../push-notification/push-notification.module';
import { TopHeaderComponent } from './header/header.component';
import { HorizontalLoginComponent } from './header/horizontal-login/horizontal-login.component';
import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
    declarations: [
        TopHeaderComponent
        , HorizontalLoginComponent
        , SpinnerComponent
    ]
    , imports: [
        CommonModule
        , RouterModule
        , SharedModule
        , MatProgressBarModule
        , MatProgressSpinnerModule
        , QuickUserInfoComponent
        , PushNotificationModule
        , CiComplaintsComponent
        , PrimeNgModule
        , InvWorkstationComponent
    ]
    , exports: [
        TopHeaderComponent
        , SpinnerComponent
        , MatProgressSpinnerModule
    ]
})
export class LayoutModule { }
